module.exports = __webpack_public_path__ + "static/media/dark_digitalMarketing_bg.c5a46967.jpg";